import * as dotProp from 'dot-prop-immutable';
import { Action } from 'typescript-fsa';

import { login, logout } from './auth.actions';
import { createReducer } from '../../frontendUtils/redux';
import { updateProfile } from '../profile/profile.actions';
import { User } from '@api/types.generated';

export type UserAuth = {
  token: string;
  user: {
    email: string;
    token: string;
    locale: string;
  };
};

export type AuthState = {
  readonly user: User | null;
};

export const initialState: AuthState = {
  user: null,
};

const authReducer = createReducer(initialState, {
  [login.started.type]: (state: AuthState) => {
    return dotProp.set(state, 'user', null);
  },
  [login.done.type]: (state: AuthState, action: Action<{ result: UserAuth }>) => {
    const { user, token } = action.payload.result;
    return dotProp.set(state, 'user', { ...user, token });
  },
  [logout.type]: (state: AuthState) => {
    return dotProp.set(state, 'user', null);
  },
  [updateProfile.done.type]: (state: AuthState, action: Action<{ result: UserAuth }>) => {
    return dotProp.set(state, 'user', {...state.user, ...action.payload.result });
  },
});

export default authReducer;
